import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import blogStyle from 'styles/css/BlogStyles.module.scss';
import { API_BLOG } from 'apis';
import apiRequest from 'utils/apiRequest';
import { handleChangeDataPageBlog } from 'reduxx/actions/pages/blog';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

const BlogDetails = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token } = useSelector(state => state.login);
    const { content, detailsIndex } = useSelector(state => state.blog);
    const item = content[detailsIndex];

    useEffect(() => {
        if(detailsIndex === null)
            navigate(`/blog`);
    }, [BlogDetails]);

    return (
        
        <div className={[sharedStyles['container-width'], sharedStyles.bgwhite].join(' ')} style={{paddingBottom: '96px'}}>

            {item &&
            <div className={[sharedStyles.flex, sharedStyles['flex-col'], blogStyle['item-blog']].join(' ')}>
                { item.media == null ?
                    <img src={item.thumbnail} alt={item.title} style={{aspectRatio: '1/1'}} />
                    :
                    <video
                        src={item.media}
                        controls
                        preload="metadata"
                        playsInline
                        style={{ width: '100%', borderRadius: '12px' }}
                    >
                        مرورگر شما از ویدئو پشتیبانی نمی‌کند
                    </video>
                }
                <h2 className={[sharedStyles['px-lg']].join(' ')} style={{marginBottom: '0'}}>{item.title}</h2>
                <p className={[sharedStyles['px-lg'], sharedStyles.textJustify].join(' ')} style={{marginBottom: '0'}}>{item.text}</p>
            </div>
            }
                    

        </div>

    );
}

export default BlogDetails;